module.exports = __webpack_public_path__ + "img/icon-text.fd52a928.svg";